import { BootInfo } from '@neovici/core/context/boot-info.js';
import { CNL } from '../cz-cnl-rule-config/types';
import { ActionDescription, AvailableAction, PerformableAction } from './types';

// TODO: move all of this to BE

const SupplierInvoice_PaymentConsent = 'SupplierInvoice_PaymentConsent';

const fakeActions: Partial<Record<AvailableAction, ActionDescription>> = {
	[SupplierInvoice_PaymentConsent]: {
		title: 'Approve payment',
		batch: false,
		defaultHidden: false,
		handleBatchInOneConsumer: false,
		requiresCheck: false,
		showComment: false,
		simpleAction: true,
		notifiable: false,
		cnl: [
			{
				label: 'QR Code',
				type: 'payment_consent',
				id: 'paymentConsent',
				required: true,
				allowManualInput: false,
				keepOpened: false,
				lookup: false,
				multiple: false,
				readonly: true,
			},
		] as CNL as any,
	},
};

export const injectExtraActions = (boot: BootInfo) => {
	boot.actions = { ...fakeActions, ...boot.actions };
};

const wizards: Partial<Record<AvailableAction, PerformableAction>> = {
	SupplierInvoice_InitiatePayment: {
		action: SupplierInvoice_PaymentConsent,
	},
};

type Opts = {
	action: AvailableAction;
};
export const fakePerform$ =
	<O extends Opts>(perform$: (opts: O) => Promise<any>) =>
	(options: O) => {
		const action = options.action;

		if (Object.keys(fakeActions).includes(action)) {
			return Promise.resolve(undefined);
		}

		return perform$(options).then(() => wizards[action]);
	};
